import React from 'react'
import { Link } from 'react-router'

const styles = {
  warning: {
    color: '#FFC107',
  },
}

const SchoolProfileDigest = ({ userProfile: { first_name, avatar, verified } }) => {
  const avatarImage = avatar ? (
    <img src="{avatar}" alt="avatar" />
  ) : (
    <i className="fa fa-user" aria-hidden="true" />
  )

  const notVerified = verified === false

  return (
    <div className="profile-digest">
      {/* <Link to="/dashboard/profile">
        <div className="profile-pic">{avatarImage}</div>
      </Link> */}

      <Link to="/dashboard/profile">{first_name && <span>{`${first_name}`}</span>}</Link>

      {notVerified && (
        <div style={styles.warning}>
          <div>
            حساب شما هنوز به تایید مدیریت نرسیده است به همین دلیل امکان استفاده از سامانه
            را ندارید.
          </div>
          <div className="xs-hidden">توجه: از زمان ثبت نام یک هفته فرصت برای تکمیل اطلاعات خواهید داشت</div>
        </div>
      )}
    </div>
  )
}

export default SchoolProfileDigest



// WEBPACK FOOTER //
// ./src/components/school/SchoolProfileDigest.js